import React, { useState } from 'react';
import { useClinicalData } from './hooks/useClinicalData';
import './ListsManager.css';

const ListsManager = () => {
  const { structure, actions } = useClinicalData();
  const [newItem, setNewItem] = useState('');
  const [activeList, setActiveList] = useState('departmentTypes');

  const listMeta = {
    departmentTypes: 'Department Types',
    roomTypes: 'Room Types',
    bedStates: 'Bed States',
    equipmentTypes: 'Equipment Types'
  };

  const addItem = () => {
    if (!newItem.trim()) return;
    const currentList = structure[activeList] || [];
    const updatedStructure = {
      ...structure,
      [activeList]: [...currentList, newItem.trim()]
    };
    actions.setStructure(updatedStructure);
    setNewItem('');
  };

  const deleteItem = (value) => {
    const currentList = structure[activeList] || [];
    const updatedList = currentList.filter(i => i !== value);
    const updatedStructure = {
      ...structure,
      [activeList]: updatedList
    };
    actions.setStructure(updatedStructure);
  };

  return (
    <div className="lists-manager">
      <div className="lists-header">
        <div>
          <h1>🗂️ Clinical Mapping Lists</h1>
          <p>Manage controlled vocabularies used in the mapper</p>
        </div>
      </div>

      <div className="lists-content">
        <aside className="lists-sidebar">
          {Object.keys(listMeta).map((key) => (
            <button
              key={key}
              className={`lists-nav-item ${activeList === key ? 'active' : ''}`}
              onClick={() => setActiveList(key)}
            >
              {listMeta[key]}
            </button>
          ))}
        </aside>

        <section className="lists-panel">
          <div className="lists-panel-header">
            <h3>{listMeta[activeList]}</h3>
            <span className="count-badge">{structure[activeList].length}</span>
          </div>

          <div className="crud-list">
            {structure[activeList].map((item, idx) => (
              <div key={`${item}-${idx}`} className="crud-item">
                <span>{item}</span>
                <button onClick={() => deleteItem(item)}>🗑️</button>
              </div>
            ))}
          </div>

          <div className="crud-add">
            <input
              type="text"
              value={newItem}
              onChange={(e) => setNewItem(e.target.value)}
              placeholder={`Add new ${listMeta[activeList].toLowerCase()}...`}
              onKeyDown={(e) => e.key === 'Enter' && addItem()}
            />
            <button onClick={addItem}>+ Add</button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ListsManager;


